import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import * as resetPasswordActions from './resetPasswordActions';

import { linkSubscribe } from './../../conf/config';

import AskResetPasswordMailForm from './../forms/askResetPasswordMailForm';
import ResetPasswordForm from './../forms/resetPasswordForm';

import Aux from './../../hoc/_Aux';
import Zigzag from './../../containers/UI/Common/Shapes/Zigzag';
import Image from './../../containers/UI/Image/Image';
import MessageModal from './../../containers/UI/MessageModal/MessageModal';

//-- Utils
import { pushHeaderTitle } from '../../utils/dom/helper';
import { pushPageView } from '../../utils/tracking/customGtm';

// Assets
import MonstreImg from '../../assets/images/kiddy.svg';


export class ResetPassword extends Component {

    componentDidMount() {
        //-- Update title
        pushHeaderTitle('Mot de passe oublié');

        //-- Push GTM page view
        pushPageView();
    }

    componentWillUnmount(){
        const { dispatch } = this.props;
        dispatch(resetPasswordActions.reset());
    }

    closeModalHandler = () => {
        const { dispatch } = this.props;
        dispatch(resetPasswordActions.closeModal());
    }

    closeModalAndQuitHandler = () => {
        const { dispatch } = this.props;
        dispatch(resetPasswordActions.closeModal());
        dispatch( push('/login') );
    }

    closeModalOnErrorHandler = () => {
        const { dispatch } = this.props;
        dispatch(resetPasswordActions.closeModal());
        dispatch( push('/reset-password') );
    }

    modalAbonnementLink = (event) => {
        event.preventDefault();
        window.open(linkSubscribe, '_blank');
    }

    quitPageHandler = () => {
        const { dispatch } = this.props;
        dispatch( push('/login') );
    }

    render(){

        const { mailSent, passwordChanged, hasError, errorLink, errorSubscribe, errorMessage } = this.props;

        const blockResetPassword = false;

        let clickEvent = this.closeModalAndQuitHandler;
        let popupClass = null;
        let image = null;
        let title = null;
        let text = null;
        let buttonText = null;
        let buttonHandler = null;
        let zigzag = false;
        let zigzagColor = false;

        if (mailSent){
            popupClass= 'reset-password';
            image = 'sent';
            title = 'c\'est parti !!!';
            text = 'Demande à tes parents de regarder dans leurs mails';
        }

        if(passwordChanged)
        {
            popupClass= 'reset-password';
            image = 'kiddy';
            title = 'c\'est parti !!!';
            text = 'Cool :)\n Tu as créé ton nouveau mot de passe pour accéder à Kids-Matin !';
            buttonText = 'Je me connecte';
            zigzag = 'yellow-shape';
            zigzagColor="#ffde39"
        }

        if(hasError){
            popupClass= 'common-error';
            clickEvent = this.closeModalHandler;
            image = 'error';
            text = errorMessage;
            zigzag = 'blue-shape';
            zigzagColor="#49d1e5"

            if(errorLink)
            {
                buttonText = 'Recommencer';
                buttonHandler = this.closeModalOnErrorHandler;
            }
            
            if(errorSubscribe)
            {
                popupClass= 'reset-password-no-subscription';
                buttonText = 'Pour t\'abonner c\'est par ici';
                buttonHandler = this.modalAbonnementLink;
            }
        }

        if(blockResetPassword)
        {
            clickEvent = this.quitPageHandler;
            image = 'error';
            title = null;
            text = 'Cette fonctionnalité n\'est pas encore disponible';
            buttonText = null;
            buttonHandler = null;
        }

        let resetPassword = (
            <div className="reset-password-page-container">
                <div id="mainCharacter">
                    <Image
                        isResponsive='true'
                        imgPath={MonstreImg}
                        imgName="intro-monstre"
                    />
                </div>
                <div className="quit-button" onClick={this.quitPageHandler}>X</div>
                <div className="yellow-shape">
                    <Zigzag color="#ffde39" />
                </div>
                <div className="enveloppe"></div>
                <div className="title">
                    J'ai oublié <div className="line-breaker">mon mot de passe</div>
                </div>
                <div className="blue-shape">
                    <Zigzag color="#49d1e5" />
                </div>
                <div className="order">
                    Demande à tes parents de regarder leur mail pour changer ton mot de passe
                </div>
                
                <AskResetPasswordMailForm class="ask-reset-password-mail-form" name="askResetPasswordMailForm"/>   
            
            </div>
        );

        if(this.props.location.search)
        {
            resetPassword = (
                <div className="reset-password-page-container">
                    <div id="mainCharacter" className="right">
                        <Image
                            isResponsive='true'
                            imgPath={MonstreImg}
                            imgName="intro-monstre"
                        />
                    </div>
                    <div className="quit-button" onClick={this.quitPageHandler}>X</div>
                    <div className="yellow-shape-2">
                        <Zigzag color="#ffde39" />
                    </div>
                    <div className="title-reset">
                        Ton nouveau mot de passe
                    </div>
                    <div className="blue-shape-2">
                        <Zigzag color="#49d1e5" />
                    </div>
                    
                    <ResetPasswordForm class="reset-password-form" name="resetPasswordForm" query={this.props.location.search} />                 
                </div>
            );
        }


        return(
            <Aux> 
                <MessageModal
                        show={blockResetPassword || mailSent || passwordChanged || hasError}
                        class={popupClass?popupClass:undefined}
                        closeModalHandler={clickEvent}
                        image={image}
                        title={title?title:undefined}
                        message={text}
                        button={buttonText?buttonText:undefined}
                        buttonHandler={buttonHandler?buttonHandler:undefined}
                        zigzagColor={zigzagColor?zigzagColor:undefined}
                        zigzagClass={zigzag?zigzag:undefined}
                    />
                {resetPassword}
            </Aux>
        );
    }
}

const mapStateToProps = state => {
    return {
        mailSent: state.resetPassword.mailSent,
        passwordChanged: state.resetPassword.passwordChanged,
        hasError: state.resetPassword.hasError,
        errorLink: state.resetPassword.errorLink,
        errorSubscribe: state.resetPassword.errorSubscribe,
        errorMessage: state.resetPassword.errorMessage
    }
};


export default connect( mapStateToProps )(ResetPassword);





// WEBPACK FOOTER //
// ./src/components/ResetPassword/ResetPassword.js